import axios from 'axios'
import {setupWx} from "./utils";

// public fixIOSKeyBoardIssue = () => { // 修复IOS12下微信webview键盘收起后页面被遮挡的问题
//   if (md.os() === 'iOS' && md.version('iOS') >= 12) {
//     /* eslint-disable */
//     const setDocumentHeight = () => {
//       setTimeout(() => {
//         (document.documentElement as any).style.height = '100.1vh';
//         setTimeout(() => {
//           (document.documentElement as any).style.height = '100vh';
//         }, 100);
//       }, 100);
//     };
//     /* eslint-enable */
//     const inputEles = Array.from(document.querySelectorAll('input'));
//     const textareaEles = Array.from(document.querySelectorAll('textarea'));
//     inputEles.forEach((item) => {
//       item.addEventListener('blur', () => {
//         setDocumentHeight();
//       });
//     });
//     textareaEles.forEach((item) => {
//       item.addEventListener('blur', () => {
//         setDocumentHeight();
//       });
//     });
//   }
// }

window.Raven.config('https://3dc4c0adb0e044b0846b3d41ca1e950b@sentry.jilinchen.com/6').install()

axios.defaults.baseURL = window.apiUrl || 'https://api.nhpy.art';
axios.defaults.timeout = 10000;

var clearTokenTimer = null

axios.interceptors.request.use(
  reqConfig => {
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('token')){
      localStorage.setItem('token', urlParams.get('token'))
      if(clearTokenTimer){
        clearTimeout(clearTokenTimer)
      }
      clearTokenTimer = setTimeout(()=>{
        urlParams.delete("token")
        if (urlParams.toString().trim() === "") {
          let uri = window.location.toString()
          let clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
        }else{
          window.location.search = urlParams.toString()
        }
        clearTokenTimer = null
      }, 300)
    }
    const token = urlParams.get('token') || localStorage.getItem('token');
    if(token){
      reqConfig.headers.Authorization = 'Bearer '+token;
    }
    return reqConfig;
  },
  err => Promise.reject(err),
);

// axios.get('/osstoken').then(({data})=>{
//   localStorage.setItem("osstoken", JSON.stringify(data))
// }).catch(err=>{
//   console.error(err)
// })
//
// setInterval(()=>{
//   axios.get('/osstoken').then(({data})=>{
//     localStorage.setItem("osstoken", JSON.stringify(data))
//   }).catch(err=>{
//     console.error(err)
//   })
// }, 3000)

var global_timer = null

function forceLogout() {
  localStorage.removeItem("token");
  if(global_timer){
    clearTimeout(global_timer)
  }
  global_timer = setTimeout(()=>{
    global_timer = null
    const returnUrl = window.location.protocol+'//'+window.location.host+window.location.pathname
    window.location.href = axios.defaults.baseURL+'/auth/login?returnUrl='+returnUrl;
  }, 0)
}

axios.interceptors.response.use(response=>{
  return response
}, err => {
  if(err.response && err.response.status === 401){
    forceLogout();
    return Promise.reject(new Error("跳转中..."));
  }
  return Promise.reject(err);
});


setupWx()





// WEBPACK FOOTER //
// ./src/initAxios.js